exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".companies .column-header {\n  border-top: 2px solid #e3f0f4;\n  padding: 0.5rem 1rem;\n  color: #7091c5; }\n\n.companies .company {\n  padding: 0.75rem 1rem;\n  border-top: 2px solid #e3f0f4; }\n  .companies .company .item-actions {\n    opacity: 0;\n    transition: all 200ms ease-in; }\n  .companies .company:hover {\n    cursor: pointer; }\n    .companies .company:hover .item-actions {\n      opacity: 1; }\n  .companies .company:hover {\n    background-color: #fcf9f3; }\n  .companies .company .name {\n    font-weight: bold; }\n  .companies .company .location {\n    color: #898a8e; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/companies/company-list/company-list.component.scss
// module id = 390
// module chunks = 0